// Flag primary colors + ISO numeric codes for topojson matching.
// The world-atlas topojson uses 3-digit ISO 3166-1 numeric IDs (as strings, padded).

export const COUNTRY_COLORS = {
  SA: "#006C35", // green
  EG: "#CE1126", // red
  MA: "#C1272D", // red
  DZ: "#006233", // green
  TN: "#E70013", // red
  LY: "#239E46", // green
  SD: "#D21034", // red
  MR: "#00A95C", // green
  IQ: "#B4001F", // red
  JO: "#007A3D", // green
  LB: "#ED1C24", // red (cedar)
  SY: "#007A3D", // green
  YE: "#CE1126", // red
  OM: "#DB161B", // red
  AE: "#00732F", // green
  QA: "#8D1B3D", // maroon
  BH: "#DA291C", // red
  KW: "#007A3D", // green
  DJ: "#6AB2E7", // sky blue
  SO: "#4189DD", // blue
  KM: "#3A75C4", // blue
  PS: "#149954", // green
  EH: "#C4111B", // red — rendered with hatched overlay for disputed
};

// ISO 3166-1 alpha-2 -> numeric (3-digit strings, matching world-atlas 110m ids)
export const ISO_NUMERIC = {
  SA: "682",
  EG: "818",
  MA: "504",
  DZ: "012",
  TN: "788",
  LY: "434",
  SD: "729",
  MR: "478",
  IQ: "368",
  JO: "400",
  LB: "422",
  SY: "760",
  YE: "887",
  OM: "512",
  AE: "784",
  QA: "634",
  BH: "048",
  KW: "414",
  DJ: "262",
  SO: "706",
  KM: "174",
  PS: "275",
  EH: "732",
};

// Reverse map numeric -> alpha-2
export const NUMERIC_TO_ALPHA = Object.fromEntries(
  Object.entries(ISO_NUMERIC).map(([a, n]) => [n, a]),
);

export function colorFor(code) {
  return COUNTRY_COLORS[code] || "#EBDDC2";
}
